import { InfoAboutUploadConfirmItem, InfoAboutUploadItem, InfoAboutUploadRenderItem } from 'entities/users/types';
import { CitiesListType } from 'features/getCities/types';

export const mapInfoAboutUploadToRender = (
  source: InfoAboutUploadItem[],
  citiesList: CitiesListType[],
): InfoAboutUploadRenderItem[] =>
  source.map((sourceItem) => ({
    city: citiesList.find((city) => city.id === sourceItem.user.city_id)?.name as string,
    client_number: sourceItem.user.phone ?? '-',
    address: sourceItem.sales_point.title ?? '-',
    title: sourceItem.sales_point.title ?? '-',
    phone: sourceItem.user.phone ?? '-',
    personal_number: '-',
    date_end: sourceItem.user.passport_expiration_at ?? '-',
    date_start: sourceItem.user.passport_issued_at ?? '-',
    fio:
      sourceItem.user.last_name && sourceItem.user.first_name
        ? `${sourceItem.user.last_name} ${sourceItem.user.first_name}${
            sourceItem.user.middle_name ? ` ${sourceItem.user.middle_name}` : ''
          }`
        : '-',
    iin: sourceItem.user.iin ?? '-',
    door_code: sourceItem.sales_point.door_code ? sourceItem.sales_point.door_code.toString() : '-',
    passport_number: sourceItem.user.passport_number ?? '-',
    passport_issued_at: sourceItem.user.passport_issued_at ?? '-',
    passport_expiration_at: sourceItem.user.passport_expiration_at ?? '-',
    old_phone: sourceItem.user.old_phone ?? '-',
    bonuses_amount:
      sourceItem.user.bonuses && sourceItem.user.bonuses
        ? sourceItem.user.bonuses.reduce((prev, cur) => prev + cur.amount, 0).toString()
        : '-',
  }));

export const mapInfoAboutUploadToConfirm = (source: InfoAboutUploadItem[]): InfoAboutUploadConfirmItem[] =>
  source.map((sourceItem) => ({
    address: sourceItem.sales_point.title,
    city_id: sourceItem.sales_point.city_id,
    door_code: sourceItem.sales_point.door_code.toString(),
    first_name: sourceItem.user.first_name,
    last_name: sourceItem.user.last_name,
    iin: sourceItem.user.iin,
    middle_name: sourceItem.user.middle_name,
    passport_expiration_at: sourceItem.user.passport_expiration_at,
    passport_issued_at: sourceItem.user.passport_issued_at,
    phone: sourceItem.user.phone,
    passport_number: sourceItem.user.passport_number,
    title: sourceItem.sales_point.title,
  }));
